export default __webpack_public_path__ + "static/media/outline-icons.53671035.ttf";